/* eslint-disable  no-unused-vars */
import React, { useState } from 'react';
import Logo from '../../images/Logo.png';
import { connect, useSelector } from 'react-redux';
import { Field, reduxForm, getFormSyncErrors, submit, formValueSelector, reset as resetForm } from 'redux-form';
import Input from '../utils/Input';
import TextArea from '../utils/TextArea';
import '../../sass/ModalContact.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faFacebookMessenger, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { API_SERVER } from '../../helpers/URLs';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const selector = formValueSelector('ModalContact')

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 600,
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

const validate = values => {
    const errors = {}

    if (!values.NombreModal) {
        errors.NombreModal = 'Campo obligatorio'
    }

    if (!values.CorreoModal) {
        errors.CorreoModal = 'Campo requerido'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.CorreoModal)) {
        errors.CorreoModal = 'Correo invalido'
    }

    if (!values.AsuntoModal) {
        errors.AsuntoModal = 'Campo requerido'
    }

    if (!values.MensajeModal) {
        errors.MensajeModal = 'Campo requerido'
    }

    return errors
}


let ModalContact = ({ handleSubmit, submitting, synchronousError, sendMessage, datosCliente, resetDataCliente }) => {


    const enlaces = useSelector(state => state.enlaces);
    const puntosContacto = useSelector(state => state.puntosContacto);
    const [sending, setSending] = useState(false);
    const classes = useStyles();

    const [openAlert, setOpenAlert] = React.useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [delayDuration, setDelayDuration] = useState(6000);
    const [actionStatus, setActionStatus] = useState("ENVIAR MENSAJE");

    const handleAlertStack = () => {
        setOpenAlert(true);
    };

    const handleAlertStackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
    };

    const handleButtonClick = (strMensajePre, streMensajePost) => {
        
        setActionStatus(strMensajePre);
        setShowSuccess(true);

        // Use setTimeout to simulate a delayed action
        setTimeout(() => {
            setActionStatus(streMensajePost);
            setShowSuccess(false);
        }, delayDuration);
    };

    const handeSend = () => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            body: JSON.stringify({
                "Nombre": datosCliente.nombres,
                "Asunto": datosCliente.asunto,
                "Correo": datosCliente.correo,
                "Parrafo": datosCliente.mensaje
            })
        };

        setSending(true)
        fetch(`${API_SERVER}/Interamerican/Mensajes`, requestOptions)
            .then(async response => {
                const data = await response.json();

                if (!response.ok) {
                    const error = (data && data.message) || response.status;

                    return Promise.reject(error);
                } else {
                    if (parseInt(data.Id) > 0) {
                        handleButtonClick("MENSAJE ENVIADO", "ENVIAR MENSAJE");
                    }
                    setSending(false);
                    resetDataCliente();
                    //handleAlertStack();
                }

            })
            .then(response => console.log(response))
            .catch(error => {
                console.error('There was an error!', error);
                setSending(false)
            });
    }


    return (
        <>
            <div className="modal fade" id="ContactosModal" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content modal-contact">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><FontAwesomeIcon icon={faTimes} /></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        {(!showSuccess) ? <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h2>CONTÁCTANOS</h2>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <small>* Llenar todos los campos obligatorios</small>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field name="NombreModal" label="* NOMBRE" component={Input} type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field name="CorreoModal" label="* CORREO ELECTRÓNICO" component={Input} type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field name="AsuntoModal" label="* ASUNTO" component={Input} type="text" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field name="MensajeModal" label="* MENSAJE" component={TextArea} type="text" />
                                                </div>
                                            </div>
                                        </>
                                            :
                                            <>
                                                <div className="row">
                                                    <Grid container alignItems="center">
                                                        <Grid item xs>
                                                            <Typography gutterBottom variant="h4">
                                                                Gracias por contactarnos
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography gutterBottom variant="h6">
                                                                <EmailOutlinedIcon />
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Typography color="subtitle2" variant="body2">
                                                        En breve responderemos tu mensaje
                                                    </Typography>
                                                 
                                                </div>
                                            </>
                                        }
                                        {(!showSuccess) &&
                                            <>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <button onClick={
                                                            () => {
                                                                sendMessage()
                                                                synchronousError && handeSend()
                                                            }}
                                                            type="submit" className="btn btn-interamerican" disabled={submitting}>
                                                            {
                                                                !sending ? actionStatus :
                                                                    <p>
                                                                        <span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>  ENVIANDO...
                                                                    </p>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="col-lg-1"></div>
                                    <div className="col-lg-5 box-social">

                                        {
                                            puntosContacto.find(w => w.Id === "ATC") && <>
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <h3 className="subtitle">{puntosContacto.find(w => w.Id === "ATC").Nombre}</h3>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <p>Teléfono: {puntosContacto.find(w => w.Id === "ATC").Telefono}<br />
                                                            {puntosContacto.find(w => w.Id === "ATC").Correo}
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {
                                            puntosContacto.find(w => w.Id === "RES") && <>
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <h3 className="subtitle">{puntosContacto.find(w => w.Id === "RES").Nombre}</h3>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-auto">
                                                        <p>Teléfono: {puntosContacto.find(w => w.Id === "RES").Telefono}<br />
                                                            {puntosContacto.find(w => w.Id === "RES").Correo}
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className="row">
                                            <div className="col-auto">
                                                <h3 className="subtitle">Encuéntranos en:</h3>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-auto social-media">
                                                <a href={enlaces.find(w => w.Id === "FACEBOOK")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "FACEBOOK")?.URL} className="icon-facebook"><i><FontAwesomeIcon icon={faFacebookF} /></i></a>
                                                <a href={enlaces.find(w => w.Id === "MESSENGER")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "MESSENGER")?.URL} className="icon-messenger"><i><FontAwesomeIcon icon={faFacebookMessenger} /></i></a>
                                                <a href={enlaces.find(w => w.Id === "WHATSAPP")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "WHATSAPP")?.URL} className="icon-whatsapp"><i><FontAwesomeIcon icon={faWhatsapp} /></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <img className="brand-image" src={Logo} alt="..." />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className={classes.root} style={{ width: '100vw' }}>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            autoHideDuration={3500}
                            open={openAlert}
                            onClose={handleAlertStackClose}
                            message={"MENSAJE ENVIADO..."}
                            action={
                                <IconButton size="small" aria-label="close" color="inherit" onClick={handleAlertStackClose}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    synchronousError: getFormSyncErrors('ModalContact')(state),
    datosCliente: {
        nombres: selector(state, 'NombreModal'),
        correo: selector(state, 'CorreoModal'),
        asunto: selector(state, 'AsuntoModal'),
        mensaje: selector(state, 'MensajeModal'),
    },
    initialValues: {}
})

const mapDispatchToProps = dispatch => ({
    sendMessage: () => dispatch(submit('ModalContact')),
    resetDataCliente: () => dispatch(resetForm("ModalContact"))
})

ModalContact = reduxForm({
    form: 'ModalContact',
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    validate
})(ModalContact)


export default connect(mapStateToProps, mapDispatchToProps)(ModalContact) 
